/* eslint-disable react/prefer-stateless-function */
import React from "react";
import { withRouter } from "react-router-dom";

class Sms5KgDone extends React.Component {
  render() {
    const { isSuccess } = this.props;

    return (
      isSuccess
        ? (
          <div style={{ direction: "rtl", width: "310px", margin: "0 auto" }}>
            <h2>הפרטים הועברו למערכת</h2>
            <h1>תודה!</h1>
          </div>
        ) : (
          <div style={{ direction: "rtl", width: "310px", margin: "0 auto" }}>
            <h2>יש בעיה בעדכון הפרטים במערכת</h2>
            <h2>אנא נסו שוב מאוחר יותר!</h2>
          </div>
        )
    );
  }
}

// withRouter will set the location as this.props.location
const connectedSms5KgDone = withRouter(Sms5KgDone);
export { connectedSms5KgDone as Sms5KgDone };
